<template>
<section>
  <h2>Collapse 折叠面板</h2>
  <p class="desc">将内容区域折叠/展开</p>
  <h2>基础用法</h2>
  <div class="container">
    <div class="example">
      <y-collapse v-model="value">
        <y-collapse-item title="1">
          <div slot="content">内容1</div>
        </y-collapse-item>
        <y-collapse-item title="2">
          <div slot="content">内容2</div>
        </y-collapse-item>
        <y-collapse-item title="3">
          <div slot="content">内容3</div>
        </y-collapse-item>
      </y-collapse>
    </div>
    <div class="code-wrapper" v-highlight>
      <pre class="code"><code class="html" v-text="text1"></code></pre>
    </div>
  </div>
  <h2>手风琴模式</h2>
  <div class="container">
    <div class="example">
      <y-collapse v-model="value2" accordion>
        <y-collapse-item title="1">
          <div slot="content">内容1</div>
        </y-collapse-item>
        <y-collapse-item title="2">
          <div slot="content">内容2</div>
        </y-collapse-item>
        <y-collapse-item title="3">
          <div slot="content">内容3</div>
        </y-collapse-item>
      </y-collapse>
    </div>
    <div class="code-wrapper" v-highlight>
      <pre class="code"><code class="html" v-text="text2"></code></pre>
    </div>
  </div>
  <h2>Attributes</h2>
  <div class="attr">
    <table>
      <thead>
        <tr>
          <th>参数</th>
          <th>说明</th>
          <th>类型</th>
          <th>可选值</th>
          <th>默认值</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>value</td>
          <td>设置折叠面板默认打开项</td>
          <td>Array</td>
          <td>--</td>
          <td>--</td>
        </tr>
        <tr>
          <td>accordion</td>
          <td>是否开启手风琴模式</td>
          <td>Boolean</td>
          <td>--</td>
          <td>false</td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
</template>
<script>
export default {
  data () {
    return {
      text1: `<y-collapse v-model="value">
  <y-collapse-item title="1">
    <div slot="content">内容1</div>
  </y-collapse-item>
  <y-collapse-item title="2">
    <div slot="content">内容2</div>
  </y-collapse-item>
  <y-collapse-item title="3">
    <div slot="content">内容3</div>
  </y-collapse-item>
</y-collapse>
data () {
  return {
    value: [1,2]
  }
}`,
      text2: `<y-collapse v-model="value" accordion>
  <y-collapse-item title="1">
    <div slot="content">内容1</div>
  </y-collapse-item>
  <y-collapse-item title="2">
    <div slot="content">内容2</div>
  </y-collapse-item>
  <y-collapse-item title="3">
    <div slot="content">内容3</div>
  </y-collapse-item>
</y-collapse>
data () {
  return {
    value: [2,3]
  }
}`,
      value: [2, 3],
      value2: [2, 3],
    }
  },
}
</script>
